import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLabel } from '@angular/material/input';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { InputType } from 'enums/InputType';
import { ValidationType } from 'enums/validationType';
import { ContactModel } from 'models/generated/Entities.GormCrm.Contact';
import { ContactPhoneModel } from 'models/generated/Entities.GormCrm.ContactPhone';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'contact',
	templateUrl: './contact.component.html',
	imports: [DataTableComponent, DataRowComponent, CustomInputComponent, MatLabel, TranslatePipe]
})
export class ContactComponent implements OnInit {

	@Input() contact!: ContactModel;
	@Input() primaryContactId?: string;
	@Output() primaryContactIdChange = new EventEmitter<string>();
	@Input() billingContactId?: string;
	@Output() billingContactIdChange = new EventEmitter<string>();

	wasPrimaryAtStart = false;
	originalPrimaryContactId?= '';
	_isPrimaryContact = false;
	set isPrimaryContact(value) {
		this._isPrimaryContact = value;
		this.contact.isPrimary = value;
	}
	get isPrimaryContact() {
		return this._isPrimaryContact;
	}

	isBillingContact = false;
	inputTypeEnum = InputType;
	validationTypeEnum = ValidationType;

	setMobile(contactPhone: ContactPhoneModel) {
		contactPhone.mobile = contactPhone.number.isMobileNumber();
	}

	ngOnInit() {
		this.originalPrimaryContactId = this.primaryContactId;
		this.isPrimaryContact = this.contact.id == this.primaryContactId;
		this.wasPrimaryAtStart = this.isPrimaryContact;
		this.isBillingContact = this.billingContactId !== undefined && this.contact.id == this.billingContactId;
	}
}
